<!-- src/apps/imageToDescription/components/ProductDescriptionResults.vue -->
<template>
  <div class="results-container results-main-container" >
    <div v-if="!isEmpty" class="results-content">
      <!-- Title Section -->
      <div class="result-section">
        <h3 class="content-box section-title" v-html="results?.title || '&nbsp;'"></h3>
      </div>

      <!-- Main Content Section -->
      <div class="result-section">
        <div class="content-box" v-html="results?.content || '&nbsp;'"></div>
      </div>

      <!-- Usage Section -->
      <div class="result-section">
        <h4 class="section-title">Recommended Usage</h4>
        <div class="content-box" v-html="results?.usage || '&nbsp;'"></div>
      </div>

      <!-- Hashtags Section -->
      <div class="result-section">
        <h4 class="section-title">Hashtags</h4>
        <div class="hashtags-container">
          <template v-if="hashtags.length">
            <span
                v-for="(hashtag, index) in hashtags"
                :key="index"
                class="hashtag"
            >
              {{ hashtag }}
            </span>
          </template>
          <span v-else class="placeholder-text">#your #hashtags #will #appear #here</span>
        </div>
      </div>
      <!-- Usage Section -->
      <div class="result-section">
        <h4 class="section-title">Keywords</h4>
        <div class="content-box" v-html="results?.keywords || '&nbsp;'"></div>
      </div>


    </div>

    <!-- Empty State -->
    <div v-else class="empty-state">
      <div class="empty-state-content">
        <i class="fas fa-file-alt fa-3x mb-3"></i>
        <h3>No Description Generated Yet</h3>
        <p>Upload an image and generate a description to see the results here</p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'ProductDescriptionResults',

  props: {
    results: {
      type: Object,
      default: null
    },
    isEmpty: {
      type: Boolean,
      default: true
    }
  },

  setup(props) {
    const hashtags = computed(() => {
      if (!props.results?.hashtags) return [];
      return props.results.hashtags.split(' ');
    });

    return {
      hashtags
    };
  }
};
</script>

<style scoped>
/* ... previous styles ... */

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}

.empty-state-content {
  text-align: center;
  color: #6c757d;
}

.empty-state-content h3 {
  margin-bottom: 0.5rem;
}

.empty-state-content p {
  margin-bottom: 0;
}

.placeholder-text {
  color: #6c757d;
  font-style: italic;
}
</style>